import { render, staticRenderFns } from "./choseCommodity.vue?vue&type=template&id=5d04bc93&scoped=true&"
import script from "./choseCommodity.vue?vue&type=script&lang=js&"
export * from "./choseCommodity.vue?vue&type=script&lang=js&"
import style0 from "./choseCommodity.vue?vue&type=style&index=0&id=5d04bc93&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d04bc93",
  null
  
)

export default component.exports